import {
  SR_API_ACTION_GET_NEIGHBORHOOD_LIST,
} from 'api/actionTypes';

export default async function getNeighborhoodsByMarketId({ state, apiClient }, marketId) {
  if (!state.get(['markets', 'neighborhoodsByMarketId', marketId])) {
    await apiClient.postWithState({
      action: SR_API_ACTION_GET_NEIGHBORHOOD_LIST,
      state: state,
      payload: {
        marketId,
      },
      onSuccess(neighborhoodList) {
        state.set(['markets', 'neighborhoodsByMarketId', marketId], neighborhoodList);
      },
    });
  }
}
